import React, { Fragment } from 'react';
import { CustomTable, TableColumn } from '@/components/Table';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { EventProductMainReport } from '@/model/EventProductMainReport';
import { EventProductDetailReportV2 } from '@/model/EventProductDetailReportV2';
import SuperCollapse from '@/components/sharedComponents/SuperCollapse';
import { ReportDropdownHeader } from '../../ReportDropdownHeader';

interface StateProps {
  main: EventProductMainReport;
}

export const SaleProductProductsContent: React.FC<StateProps> = ({ main }) => {
  const defaultColumns: TableColumn<any>[] = [
    {
      name: 'Produto',
      selector: row => row.productName,
    },
    {
      name: 'Vendidos',
      selector: row => row.productSold,
    },
    {
      name: 'Valor',
      selector: row => row.productValue,
    },
    {
      name: 'Venda',
      selector: row => row.totalSaleVale,
    },
    {
      name: 'Comissão',
      selector: row => row.totalCommission,
    },
    {
      name: 'Venda + comissão',
      selector: row => row.totalSaleValueWithCommission,
    },
    {
      name: 'Estoque inicial',
      selector: row => row.initialInventory,
    },
    {
      name: 'Estoque disponível',
      selector: row => row.availableStock,
    },
  ];

  const withoutStockColumns: TableColumn<any>[] = [
    {
      name: 'Produto',
      selector: row => row.productName,
    },
    {
      name: 'Vendidos',
      selector: row => row.productSold,
    },
    {
      name: 'Valor',
      selector: row => row.productValue,
    },
    {
      name: 'Venda',
      selector: row => row.totalSaleVale,
    },
    {
      name: 'Comissão',
      selector: row => row.totalCommission,
    },
    {
      name: 'Venda + comissão',
      selector: row => row.totalSaleValueWithCommission,
    },
  ];

  const getColumns = (products: EventProductDetailReportV2[]): TableColumn<any>[] => {
    let showStock = false;
    // eslint-disable-next-line no-plusplus
    for (let p = 0; p < products.length; p++) {
      if (products[p].initialInventory > 0 || products[p].availableStock > 0) {
        showStock = true;
        break;
      }
    }
    if (showStock) {
      return defaultColumns;
    }
    return withoutStockColumns;
  };

  return (
    <Fragment>
      <div className="mb-4">
        {main && main.products && main.products.length > 0 && (
          <div className="mb-3">
            <SuperCollapse
              title={
                <ReportDropdownHeader
                  title="Vendas Gerais por Produto"
                  customItemsCount={main.products.reduce(
                    (acc, curr) => acc + (curr.productsSold || 0),
                    0,
                  )}
                  customTotalValue={main.products.reduce(
                    (acc, curr) => acc + (curr.totalSaleVale || 0),
                    0,
                  )}
                  customCommissionValue={main.products.reduce(
                    (acc, curr) => acc + (curr.totalCommission || 0),
                    0,
                  )}
                />
              }
              content={
                <div className="p-3 bg-white rounded">
                  <CustomTable
                    theme="secondaryWithoutBorder"
                    numberRowsPerPage={0}
                    progressPending={false}
                    columns={getColumns(main.products)}
                    data={main.products.map(data => ({
                      productName: data.productName,
                      productSold: data.productsSold,
                      initialInventory: data.initialInventory,
                      availableStock: data.availableStock,
                      productValue: toCurrency(data.productValue),
                      totalSaleVale: toCurrency(data.totalSaleVale),
                      totalCommission: toCurrency(data.totalCommission),
                      totalSaleValueWithCommission: toCurrency(data.totalSaleValueWithCommission),
                    }))}
                  />
                </div>
              }
            />
          </div>
        )}

        {main && main.courtesies && main.courtesies.length > 0 && (
          <Fragment>
            {main.courtesies.map(userCourtesy => (
              <div
                key={userCourtesy.userId || userCourtesy.userName || 'unidentified'}
                className="mb-3"
              >
                <SuperCollapse
                  title={
                    <ReportDropdownHeader
                      title={`Cortesia - ${userCourtesy.userName || 'Usuário Não Identificado'}`}
                      customCourtesiesCount={userCourtesy.totalProductsSold}
                    />
                  }
                  content={
                    <div className="p-3 bg-white rounded">
                      <CustomTable
                        theme="secondaryWithoutBorder"
                        numberRowsPerPage={0}
                        progressPending={false}
                        columns={[
                          {
                            name: 'Produto',
                            selector: row => row.productName,
                          },
                          {
                            name: 'Quantidade Emitida',
                            selector: row => row.productsSold,
                          },
                        ]}
                        data={userCourtesy.products || []}
                      />
                    </div>
                  }
                />
              </div>
            ))}
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};
